import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const updateAllCancelledNonProcessed = async (): Promise<boolean> =>
  axios.post(`/management/unit/UpdateAllCancelledNonProcessed`).then((res) => res?.data?.result)

export const useManagementUpdateAllCancelledNonProcessed = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['updateAllCancelledNonProcessed'],
    mutationFn: () => updateAllCancelledNonProcessed(),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated all non processed.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to update all non processed.')
      }
    },
    throwOnError: false
  })
